import { createApi } from "@reduxjs/toolkit/query/react";

import { REQUEST_METHODS } from "@/constants/global-constants";
import { CustomerPortalLoginData } from "@/interfaces/customer-portal/general.interface";
import { LoginResponseType, getInfoProps } from "@/interfaces/interfaces";
import { BaseWithAuth } from "@/utils/helpers";

// Function to get the token from localStorage dynamically

// Auth APIS
export const customerGeneralApi = createApi({
  reducerPath: "customerGeneralApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["info"],
  endpoints: (builder) => ({
    // get the info for customer
    getInfo: builder.query<CustomerPortalLoginData, string>({
      query: () => `customer/auth/info`,
      transformResponse: (response: APIResponse<CustomerPortalLoginData>) =>
        response?.data,
    }),
    getCustomerFromPortal: builder.query<
      CustomerPortalLoginData,
      { userId: string }
    >({
      query: ({ userId }) => `customer/user/${userId}`,

      transformResponse: (response: APIResponse<CustomerPortalLoginData>) =>
        response?.data,
    }),
    getUserInfo: builder.query<CustomerPortalLoginData, string>({
      query: (customerId) => `customer/${customerId}/user/info`,

      transformResponse: (response: APIResponse<CustomerPortalLoginData>) =>
        response?.data,
    }),

    getCustomerInfo: builder.query<getInfoProps, string>({
      query: (customerId) => `customer/${customerId}/info`,
      transformResponse: (response: APIResponse<getInfoProps>) =>
        response?.data,
    }),

    loginPortal: builder.mutation<
      LoginResponseType,
      Partial<{ data: object; method: "login" | "verify" }>
    >({
      query: ({ data, method }) => ({
        url: `customer/auth/${method}`,
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      transformResponse: (response: LoginResponseType) => response,
    }),
  }),
});

export const {
  useGetInfoQuery,
  useGetCustomerFromPortalQuery,
  useGetUserInfoQuery,
  useLazyGetCustomerInfoQuery,
  useLoginPortalMutation,
} = customerGeneralApi;
